import { defineComponent as F, ref as s, computed as $, onMounted as _, onBeforeUnmount as k, watch as y, createElementBlock as S, openBlock as p, normalizeClass as C } from "vue";
const D = F({
  name: "FormDataForm",
  props: {
    // Main form identifier - must provide url
    url: {
      type: String,
      required: !0
    },
    debug: {
      type: Boolean,
      default: !1
    },
    globalPropName: {
      type: String,
      default: "joy"
    },
    // Display mode for the form
    mode: {
      type: String,
      default: "inline",
      validator: (e) => ["inline", "popup", "sidebar", "floating"].includes(e)
    },
    // Trigger type
    trigger: {
      type: String,
      default: "none",
      validator: (e) => ["none", "fab", "tab"].includes(e)
    },
    // Optional parameters to pass to the form
    params: {
      type: Object,
      default: () => ({})
    },
    // Optional element ID for this form instance
    id: {
      type: String,
      default: void 0
    },
    // Configuration options for different modes
    inline: {
      type: Object,
      default: () => ({})
    },
    popup: {
      type: Object,
      default: () => ({})
    },
    sidebar: {
      type: Object,
      default: () => ({})
    },
    floating: {
      type: Object,
      default: () => ({})
    },
    // Configuration for overlay
    overlay: {
      type: Object,
      default: () => ({})
    },
    // Configuration for triggers
    fab: {
      type: Object,
      default: () => ({})
    },
    tab: {
      type: Object,
      default: () => ({})
    },
    iframeStyle: {
      type: Object
    },
    iframeAttributes: {
      type: Object
    }
  },
  emits: ["apiHandle"],
  setup(e, { emit: c }) {
    const t = e.globalPropName, f = s(!1), a = s(null), o = e.id || `formdata-${Date.now()}-${Math.floor(Math.random() * 1e3)}`, m = s(null), w = $(() => e.mode === "inline" ? "formdata-form-container" : "formdata-form-container-hidden"), j = async () => new Promise(async (n, d) => {
      var r;
      if (window[t]) {
        n();
        return;
      }
      window[t] = function(...l) {
        var u;
        ((u = window[t]).q ?? (u.q = [])).push(l);
      }, (r = window[t]).init ?? (r.init = (l) => new Promise((u) => window[t]("init", l || {}, u)));
      const i = document.createElement("script");
      i.src = "https://embed.jolly.tools/widget.js", i.id = t, i.async = !0, i.onerror = d, document.body.appendChild(i), await window[t].init({ debug: e.debug }), n();
    }), b = async () => {
      if (!e.url) {
        console.error("URL must be provided to FormDataForm component");
        return;
      }
      f.value || await j();
      const n = {
        url: e.url,
        id: o,
        mode: e.mode,
        trigger: e.trigger,
        params: e.params,
        debug: e.debug,
        iframeStyle: e.iframeStyle,
        iframeAttributes: e.iframeAttributes
      };
      e.mode === "inline" && Object.keys(e.inline).length > 0 && (n.inline = {
        ...e.inline
      }, !n.inline.selector && a.value && (n.inline.selector = `#${a.value.id}`, a.value.id || (a.value.id = `formdata-container-${o}`, n.inline.selector = `#${a.value.id}`))), e.mode === "popup" && Object.keys(e.popup).length > 0 && (n.popup = { ...e.popup }), e.mode === "sidebar" && Object.keys(e.sidebar).length > 0 && (n.sidebar = { ...e.sidebar }), e.mode === "floating" && Object.keys(e.floating).length > 0 && (n.floating = { ...e.floating }), e.trigger === "fab" && Object.keys(e.fab).length > 0 && (n.fab = { ...e.fab }), e.trigger === "tab" && Object.keys(e.tab).length > 0 && (n.tab = { ...e.tab }), ["popup", "sidebar", "floating"].includes(e.mode) && Object.keys(e.overlay).length > 0 && (n.overlay = { ...e.overlay });
      const d = (i = 5, r = 300) => {
        if (i <= 0) {
          console.error(`Failed to render form after multiple attempts. Joy function name: ${t}`), e.debug && console.log("Render options that failed:", n);
          return;
        }
        if (window[t] && typeof window[t] == "function") {
          e.debug && console.log("Rendering form with options:", n);
          try {
            m.value = window[t]("render", n);
          } catch (l) {
            console.error("Error rendering form:", l), setTimeout(() => d(i - 1, r * 1.5), r);
          }
        } else
          e.debug && console.log(`Joy function not ready yet. Retrying in ${r}ms. Retries left: ${i}`), setTimeout(() => d(i - 1, r * 1.5), r);
      };
      setTimeout(() => d(), 300);
    }, g = () => {
      if (window[t] && o)
        try {
          window[t]("destroy", { id: o });
        } catch (n) {
          console.error("Error destroying form:", n);
        }
    }, v = () => {
      window[t] && o && window[t]("open", { id: o });
    }, h = () => {
      window[t] && o && window[t]("close", { id: o });
    }, O = () => {
      window[t] && o && window[t]("toggle", { id: o });
    };
    return _(async () => {
      await b();
    }), k(() => {
      g();
    }), y([() => e.mode, () => e.url], async () => {
      g(), await b();
    }, { deep: !0 }), y(() => m.value, () => {
      c("apiHandle", m.value);
    }), {
      openForm: v,
      closeForm: h,
      toggleForm: O,
      containerClass: w,
      formContainer: a
    };
  }
}), R = (e, c) => {
  const t = e.__vccOpts || e;
  for (const [f, a] of c)
    t[f] = a;
  return t;
};
function P(e, c, t, f, a, o) {
  return p(), S("div", {
    class: C(e.containerClass),
    ref: "formContainer"
  }, null, 2);
}
const B = /* @__PURE__ */ R(D, [["render", P], ["__scopeId", "data-v-fb1930f7"]]), A = {
  install(e) {
    e.component("FormDataForm", B);
  }
};
export {
  B as FormDataForm,
  A as FormDataPlugin
};
